// extracted by mini-css-extract-plugin
module.exports = {"title":"Worker_title_1YQ6B","row":"Worker_row_1461N","col":"Worker_col_3hhNO"};